import { UserRound } from "lucide-react";
import Seo from "../components/site/Seo";
import { PageHero, Section, CtaBand } from "../components/site/Bits";
import { useSite } from "../lib/site";
import { mediaUrl } from "../lib/api";

export default function About() {
  const { content } = useSite();
  const a = content.about || {};
  const team = content.team?.items || [];
  return (
    <>
      <Seo title="About Us" path="/about" description="Accessible Trials & Mods is a Melbourne-based provider of assistive technology trials and home modifications for NDIS participants." />
      <PageHero eyebrow="About us" title="Helping people live well at home" intro={a.mission} image="/images/living-room.jpg" imageAlt="A bright, open living room with space to move around" />
      <Section eyebrow="Our values" title="What guides our work">
        <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {(a.values || []).map((v) => <li key={v.title} className="card p-6"><h3 className="font-display text-xl font-semibold text-teal">{v.title}</h3><p className="mt-2 text-ink-muted">{v.body}</p></li>)}
        </ul>
      </Section>
      <Section tone="bg-surface" eyebrow="Our team" title="The people you'll work with">
        <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="team-list">
          {team.map((t, i) => (
            <li key={i} className="card overflow-hidden">
              {t.photo ? <img src={mediaUrl(t.photo)} alt={`Portrait of ${t.name}`} className="aspect-square w-full object-cover" loading="lazy" />
                : <div className="grid aspect-square place-items-center bg-teal-soft"><UserRound size={72} className="text-teal" aria-hidden="true" /></div>}
              <div className="p-6"><h3 className="font-display text-xl font-semibold">{t.name}</h3><p className="font-semibold text-amber-ink">{t.role}</p><p className="mt-2 text-ink-muted">{t.bio}</p></div>
            </li>
          ))}
        </ul>
      </Section>
      <CtaBand />
    </>
  );
}
